import { DirectiveBinding } from 'vue/types/options';

export const focus = {
	inserted(el: HTMLElement, binding: DirectiveBinding): void {
		if (binding.value) el.focus();
		else el.blur();
	},

	update(el: HTMLElement, binding: DirectiveBinding): void {
		if (binding.modifiers.lazy) {
			if (Boolean(binding.value) === Boolean(binding.oldValue)) {
				return;
			}
		}

		if (binding.value) el.focus();
		else el.blur();
	},
};
